import { webapi } from '@/api/webapi.ts';
import { cancelTakeProfit } from '@/store/orders/takeProfitOrder/api/cancelTakeProfit.ts';
import { submitTakeProfit } from '@/store/orders/takeProfitOrder/api/submitTakeProfit.ts';
import { updateTakeProfit } from '@/store/orders/takeProfitOrder/api/updateTakeProfit.ts';
import { validateTakeProfit } from '@/store/orders/takeProfitOrder/api/validateTakeProfit.ts';

export const takeProfitOrderApi = webapi.injectEndpoints({
  endpoints: (builder) => ({
    validateTakeProfit: validateTakeProfit(builder),
    submitTakeProfit: submitTakeProfit(builder),
    cancelTakeProfit: cancelTakeProfit(builder),
    updateTakeProfit: updateTakeProfit(builder),
  }),
});

export const {
  useValidateTakeProfitMutation,
  useSubmitTakeProfitMutation,
  useCancelTakeProfitMutation,
  useUpdateTakeProfitMutation,
} = takeProfitOrderApi;
